import { createContext } from "react";

const watchlistContext = createContext();

export default watchlistContext;